import type { ManualAccountModalProps } from '@/components/ManualAccountModal/ManualAccountModal.types'
import { Modal } from '@/components/Modal/Modal'

import classes from './ManualAccountModal.module.css'

export function ManualAccountModal({
  children,
  onClose,
  opened,
}: ManualAccountModalProps) {
  return (
    <Modal
      centered
      classNames={classes}
      onClose={onClose}
      opened={opened}
      withCloseButton={false}
    >
      {children}
    </Modal>
  )
}
